<script lang="ts" setup>
import type { SbFooterStoryblok } from '@/types'
import { useCurrentLanguageClass } from '@/composables/useCurrentLanguageClass'

interface Props {
  blok: SbFooterStoryblok
}

defineProps<Props>()
const { currentLanguageClass } = useCurrentLanguageClass('footer-items')
</script>

<template>
  <section :class="['footer-items', currentLanguageClass]">
    <div class="footer-items__sections">
      <div v-for="section in blok.sections" :key="section._uid" class="footer-items__section">
        <p class="footer-items__section-title">
          {{ section.section_label }}
        </p>
        <ul class="footer-items__section-links">
          <li v-for="item in section.items" :key="item._uid">
            <SbFooterItem :item="item" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.footer-items {
  width: 100%;
  color: var(--color-text);

  &__sections {
    column-count: 2;
    column-gap: 40px;

    @media (min-width: $breakpoint-lg) {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      column-count: unset;
      column-gap: unset;
      align-content: space-between;
      max-height: 360px;
      row-gap: 32px;
    }
  }

  &__section {
    display: flex;
    flex-direction: column;
    break-inside: avoid;
    margin-bottom: 40px;

    @media (min-width: $breakpoint-lg) {
      margin-bottom: 0;
    }
  }

  &__section-title {
    @include paragraph-xs;

    font-weight: var(--font-weight-paragraph-bold);
    margin: 0;
    padding: 4px 0;
  }

  &__section-links {
    display: flex;
    flex-direction: column;
  }
}
</style>
